<template>
  <v-card class="left-card" elevation="3">
    <v-card-text>
      <div class="top-left-container">
        <v-icon size="16" color="#3D5769" class="mr-1"
          >mdi-clock-outline</v-icon
        >
        <span class="container-text">Instant delivery</span>
      </div>
      <v-row no-gutters>
        <v-col cols="12" md="8">
          <h3 class="text-h5 font-weight-bold mb-2">
            Indices on Demand Report
          </h3>
          <p class="body-2">
            In‑depth IoD2025 analysis (including a focus on the IMD) with
            advanced visuals and trusted benchmarks for recognised geographies
            in
            {{
              countries[this.$store.state.config.siteConfig.site_country][0]
            }}.
          </p>
        </v-col>
        <v-col cols="12" md="4" class="pa-0 mt-5 mt-md-0">
          <v-row class="pr-0 pr-md-2">
            <v-col cols="12" md="12" class="pa-0">
              <div class="d-flex d-lg-block justify-end">
                <p
                  class="small-text text-right mb-0 mr-1 mr-lg-0 d-lg-block d-md-none"
                >
                  Introductory offer
                </p>
                <div class="body-2 text-right mb-0" style="min-width: 160px">
                  <p
                    class="small-text text-right mb-0 mr-1 mr-lg-0 d-none d-md-block d-lg-none"
                  >
                    Introductory offer
                  </p>
                  <span class="price-text pt-0">£495.00</span>
                  <span class="ml-1 mr-1 mr-md-0">+ VAT</span>
                </div>
              </div>
              <div class="small-text text-right ml-1 mr-1 mr-sm-0">
                <span class="strike mr-1">£700</span>
                <span class="you-save">You save £205</span>
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <ul class="tick-list">
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Comprehensive analysis across all domains, sub‑domains and the
              overall IMD
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Tailored insights for the neighbourhoods within your chosen area
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Clear, compelling visuals
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Robust benchmarking against national and regional comparators
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Fully quality-assured data from the latest official
              {{
                countries[this.$store.state.config.siteConfig.site_country][1]
              }}
              Indices of Deprivation release
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Instant digital delivery in multiple formats
            </li>
            <li>
              <v-icon size="16" color="#3D5769" class="mr-2">mdi-check</v-icon>
              Share insights your way with a ready-to-use PDF for easy sharing,
              an editable Word document for tailoring and reporting, and a CSV
              for raw data analysis.
            </li>
          </ul>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6">
          <div
            class="download-tile clickable-tile"
            :class="{ downloading: downloadingFiles.pdf }"
            @click="onDownload('pdf')"
          >
            <div class="tile-row">
              <div class="tile-icon pdf">
                <v-icon size="20">mdi-file-pdf-box</v-icon>
              </div>
              <div class="tile-text">
                <div class="tile-title">Example Report (PDF)</div>
                <div class="tile-sub">Preview an example report</div>
              </div>
              <div class="download-icon">
                <v-progress-circular
                  v-if="downloadingFiles.pdf"
                  indeterminate
                  size="16"
                  width="2"
                  color="primary"
                />
                <v-icon v-else>mdi-download</v-icon>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6">
          <div
            class="download-tile clickable-tile"
            :class="{ downloading: downloadingFiles.csv }"
            @click="onDownload('csv')"
          >
            <div class="tile-row">
              <div class="tile-icon csv">
                <v-icon size="20">mdi-file-delimited-outline</v-icon>
              </div>
              <div class="tile-text">
                <div class="tile-title">Example data pack (.csv)</div>
                <div class="tile-sub">See included data</div>
              </div>
              <div class="download-icon">
                <v-progress-circular
                  v-if="downloadingFiles.csv"
                  indeterminate
                  size="16"
                  width="2"
                  color="primary"
                />
                <v-icon v-else>mdi-download</v-icon>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn
            width="100%"
            variant="flat"
            color="#7AD6D9"
            @click="OnDemandIncludedThemes()"
          >
            <v-icon start color="#3D5769">mdi-creation</v-icon>
            <span style="color: #3d5769">
              {{ buttonText }}
            </span>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <p class="stripe-text">
            Secure checkout Powered by
            <a
              href="https://stripe.com/"
              target="_blank"
              rel="noopener noreferrer"
              style="color: #7f7f7f; text-decoration: underline"
              >Stripe</a
            >
            • Instant delivery
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// import FormsInputsAndControls from '@/components/formsInputsAndControls'

export default {
  name: "InstantIMDReportCard",
  components: {},
  data: () => ({
    var1: "val1",
    var2: "val2",
    array: [],
    countries: {
      // England only for now
      eng: ["England", "English"],
      wls: ["England", "English"],
      sct: ["England", "English"],
      // wls: ["Wales", "Welsh"],
      // sct: ["Scotland", "Scottish"],
    },
    rightCardHeight: "auto",
    downloadingFiles: {
      pdf: false,
      csv: false,
    },
  }),
  computed: {
    buttonText() {
      return this.$vuetify.display.xs
        ? "GET YOUR REPORT"
        : "Get your Indices on Demand report";
    },
    isAnyDownloading() {
      return this.downloadingFiles.pdf || this.downloadingFiles.csv;
    },
  },
  props: {
    model: null,
    item: {},
    disable: {
      type: Boolean,
      required: false,
      default: false,
    },
    relatedModelResults: {},
  },
  mounted() {
    // this.$emit('mainComponentLoaded', this.modelName, this.subHeaderText, this.searches, '')
    this.matchCardHeights();
    window.addEventListener("resize", this.matchCardHeights);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.matchCardHeights);
  },
  methods: {
    matchCardHeights() {
      this.$nextTick(() => {
        if (this.$refs.leftCard && this.$refs.rightCard) {
          // Only match heights on larger screens (not xs)
          if (!this.$vuetify.display.sm && !this.$vuetify.display.xs) {
            const leftHeight = this.$refs.leftCard.$el.offsetHeight;
            this.rightCardHeight = `${leftHeight}px`;
          } else {
            this.rightCardHeight = "auto";
          }
        }
      });
    },
    OnDemandIncludedThemes() {
      this.$emit("button-click");
      // Fallback navigation if parent doesn't handle the event
      this.$router.push({ name: "Report outline" });
    },
    onDownload(kind) {
      // Prevent download if any download is already in progress
      if (this.isAnyDownloading) {
        return;
      }

      // Set loading state
      this.downloadingFiles[kind] = true;

      this.$axios({
        method: "GET",
        url: `/on-demand-example/${kind}`,
        responseType: "blob", // Handle binary data
      })
        .then((response) => {
          // Create blob link to download
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;

          // Get filename from custom header
          const filename =
            response.headers["x-filename"] || `example_${kind}.${kind}`;

          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);

          // Send download to analytics
          this.$axios.put("/send-analytics", {
            event: "on_demand_iod_offer_example_downloaded",
            file_type: kind,
          });
        })
        .catch(async (error) => {
          // Extract error message from backend response
          let errorMessage = "An unexpected error occurred during download";

          if (error.response?.data) {
            // If the response data is a Blob (because we're using responseType: "blob")
            if (error.response.data instanceof Blob) {
              try {
                const text = await error.response.data.text();
                const parsedData = JSON.parse(text);
                if (parsedData.message) {
                  errorMessage = parsedData.message;
                }
              } catch (e) {
                errorMessage = "Server error occurred";
              }
            } else if (error.response.data.message) {
              errorMessage = error.response.data.message;
            }
          } else if (error.message) {
            errorMessage = error.message;
          }

          this.$emit("systemMessage", {
            title: `Error! Failed to Download Example.`,
            message: errorMessage,
            timeout: -1,
            colour: "error",
          });
        })
        .finally(() => {
          // Clear loading state
          this.downloadingFiles[kind] = false;
        });
    },
  },
  watch: {},
};
</script>

<style scoped>
.no-borders td {
  border: none !important;
  padding: 0 !important;
  overflow: hidden;
}

.no-borders tr {
  border: none !important;
}

.no-borders tbody {
  padding: 0 !important;
}

.no-borders {
  padding: 0 !important;
  margin: 0 auto !important;
  max-width: 1440px;
}

.h1 {
  color: #4d4d4d !important;
  /* Headings/H1 */
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.h3 {
  color: #4d4d4d !important;
  /* Headings/H3 */
  font-family: Inter !important;
  font-size: 18px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.h4 {
  color: #4d4d4d !important;
  /* Body/Semi-bold */
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.body-1 {
  color: #4d4d4d !important;
  /* Body/Regular */
  font-family: Inter !important;
  font-size: 16px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}
.body-2 {
  color: #4d4d4d !important;
  align-self: stretch !important;
  /* Description/Regular */
  font-family: Inter !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}
.subHeaderText {
  width: 100%;
  max-width: 730px;
}

/* Prevent horizontal scroll in table cells */
.no-borders .v-row {
  margin: 0 !important;
}

.no-borders .v-col {
  padding: 8px !important;
}

.no-borders .v-card {
  width: 100%;
  box-sizing: border-box;
}

.top-left-container {
  width: 153px;
  height: 29px;
  background-color: #7ad6d9;
  border: none;
  border-radius: 0 0 var(--Spacing-XS, 4px) var(--Spacing-XS, 4px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: -16px 0 16px -18px;
}

.container-text {
  color: var(--Primary-Anchor, #3d5769);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.left-card {
  border: 2px solid #7ad6d9 !important;
  border-radius: 8px !important;
}
.small-text {
  color: #4d4d4d !important;
  /* Caption/Semi-bold */
  font-family: Inter !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: normal !important;
}
.price-text {
  color: #4d4d4d !important;
  font-family: Inter !important;
  font-size: 32px !important;
  font-style: normal !important;
  font-weight: 800 !important;
  line-height: normal !important;
}
.price-text-bespoke {
  color: var(--Common-White, #fff) !important;
  font-family: Inter !important;
  font-size: 24px !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: normal !important;
}
.strike {
  color: #4d4d4d !important;
  font-family: Inter !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
  text-decoration-line: line-through !important;
}
.you-save {
  color: #265928 !important;
  /* Caption/Medium */
  font-family: Inter !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: normal !important;
}

.tick-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tick-list li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-family: Inter;
  font-size: 14px;
  color: #4d4d4d;
}

/* Override column left padding for bullet list */
.no-borders .v-col:has(.tick-list) {
  padding-left: 0 !important;
}

/* Download tile styles */
.download-tile {
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  padding: 8px;
}

.clickable-tile {
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.clickable-tile:hover {
  background-color: rgba(0, 0, 0, 0.04);
  border-color: rgba(0, 0, 0, 0.2);
}

.clickable-tile.downloading {
  cursor: not-allowed;
  opacity: 0.7;
}

.clickable-tile.downloading:hover {
  background-color: transparent;
  border-color: rgba(0, 0, 0, 0.12);
}

.tile-row {
  display: flex;
  align-items: center;
  text-align: start;
  gap: 8px;
  flex-wrap: nowrap;
}

.tile-icon {
  width: 36px;
  height: 36px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tile-icon.pdf {
  background: rgba(179, 13, 20, 0.1);
  color: #b30d14;
}

.tile-icon.csv {
  background: rgba(17, 129, 71, 0.1);
  color: #118147;
}

.tile-text {
  flex: 1;
  min-width: 0;
  text-align: left;
}

.tile-title {
  font-size: 12px;
  font-weight: 600;
  color: #4d4d4d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tile-sub {
  font-size: 12px;
  color: #7f7f7f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.download-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #666;
  transition: color 0.2s ease-in-out;
}

.clickable-tile:hover .download-icon {
  color: #1976d2;
}
.stripe-text {
  color: #7f7f7f !important;
  text-align: center !important;
  /* Caption/Regular */
  font-family: Inter !important;
  font-size: 12px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: normal !important;
}

/* Fix button text wrapping */
.v-btn span {
  white-space: normal !important;
  word-wrap: break-word !important;
  max-width: 100% !important;
}

/* Scrollable container */
.scrollable-container {
  height: 95vh;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Price row flexbox */
.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Bespoke tick list */
.tick-list-bespoke {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tick-list-bespoke li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  font-family: Inter;
  font-size: 14px;
  color: white;
}
</style>
